export default __webpack_public_path__ + "static/media/marker-dropoff-map.fe8f038f.svg";